interface PreloaderProps {
  isLoading: boolean
  children: React.ReactNode
}

const Preloader = ({ isLoading, children }: PreloaderProps) => {
  return (
    <div className="relative">
      {isLoading && (
        <div className="absolute inset-0 bg-background/50 flex items-center justify-center z-10">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
        </div>
      )}
      {children}
    </div>
  )
}

export default Preloader 